import styled from "@emotion/styled";
import type { ComponentPropsWithoutRef } from "react";

import { MDSTextVariant } from "@/mds";

export const AgentLinkButton = ({
  truncate = false,
  ...buttonProps
}: { truncate?: boolean } & ComponentPropsWithoutRef<"button">) => (
  <StyledButton type="button" $truncate={truncate} {...buttonProps} />
);

const StyledButton = styled.button<{ $truncate: boolean }>`
  background: transparent;
  border: 0;
  color: ${({ theme }) => theme.colors.text.secondary};
  cursor: pointer;
  font: inherit;
  font-size: ${({ theme }) => theme.fontSizes[MDSTextVariant.TextS]};
  max-width: 100%;
  padding: 0;
  text-align: left;
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 3px;

  ${({ $truncate }) =>
    $truncate
      ? `
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      `
      : ""}

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
  }
`;
